import { CheckIcon } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../../../components/ui/command";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../../../components/ui/dialog";

type InterventionPickerProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  interventions?: Intervention[];
  selectedId?: number;
  onSelect: (id: number) => void;
  triggerLabel?: string;                     // default: "Interventie wijzigen"
  title?: string;                            // default: "Kies interventie"
  emptyLabel?: string;                       // default: "Geen resultaten"
};

export function InterventionPicker({
  open,
  onOpenChange,
  interventions = [],
  selectedId,
  onSelect,
  triggerLabel = "Interventie wijzigen",
  title = "Kies interventie",
  emptyLabel = "Geen resultaten",
}: InterventionPickerProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button className="w-full" onClick={() => onOpenChange(true)} disabled={interventions.length === 0}>
          {triggerLabel}
        </Button>
      </DialogTrigger>

      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <Command>
          <CommandInput placeholder="Zoek interventie..." />
          <CommandList>
            <CommandEmpty>{emptyLabel}</CommandEmpty>
            <CommandGroup className="max-h-96 overflow-auto">
              {interventions.map((it) => {
                const isSelected = it.m_iINTERVENTIESID === selectedId;
                return (
                  <CommandItem
                    key={it.m_iINTERVENTIESID}
                    value={`${it.m_iINTERVENTIESID} ${it.m_oKLANT?.m_sNAAM ?? ""} ${it.m_sOMSCHRIJVING ?? ""}`}
                    onSelect={() => onSelect(it.m_iINTERVENTIESID)}
                    className="flex items-start justify-between gap-2"
                  >
                    <div className="flex flex-col">
                      <span className="font-medium">
                        #{it.m_iINTERVENTIESID} • {it.m_oKLANT?.m_sNAAM ?? "—"}
                      </span>
                      <span className="text-xs text-muted-foreground line-clamp-1">
                        {it.m_sOMSCHRIJVING ?? "—"}
                      </span>
                    </div>
                    {isSelected && <CheckIcon className="h-4 w-4 opacity-70" />}
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  );
}